<script setup lang="ts">
const i18nHead = useLocaleHead({ key: 'id' });

useHead({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  // Follow Nuxt I18N documentation
  // https://i18n.nuxtjs.org/docs/guide/seo#feature-details
  link: [...(i18nHead.value?.link ?? [])],
  meta: [
    { property: `og:type`, content: `website` },
    { property: `og:site_name`, content: `IAD France` },
    { name: `twitter:site`, content: `@IADFrance` },
    { name: `twitter:creator`, content: `@IADFrance` },
    { name: `twitter:card`, content: `summary` },
    { name: `robots`, content: `index, follow` },
    ...(i18nHead.value?.meta ?? []),
  ],
});
</script>

<template>
  <div>
    <NuxtLoadingIndicator color="#FF7F31" />
    <MainHeader />
    <slot />
    <ClientOnly>
      <MainFooter />
    </ClientOnly>
  </div>
</template>
